import firebase from 'firebase';
import 'firebase/firestore';

const config = {
    apiKey: 'AIzaSyB__0sHJYUIm5BdBwK7Qv0bacCUKxxC4Vw',
    authDomain: 'molo-customers.firebaseapp.com',
    databaseURL: 'https://molo-customers.firebaseio.com',
    projectId: 'molo-customers',
    storageBucket: 'molo-customers.appspot.com',
    messagingSenderId: '1072822978711',
};

if (!firebase.apps.length) {
    firebase.initializeApp(config);
}

export const db = firebase.firestore();
export const { serverTimestamp } = firebase.firestore.FieldValue;
export const { auth } = firebase;



// WEBPACK FOOTER //
// ./src/config/firebase.js